<div class="p-3 pt-2 rounded-4">
    <div>
        <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0">
            <div class="p-3">Transactions</div>
        </div>
    </div>
    <div class="container-fluid mb-3 date-filter-wrapper">
        <div class="d-flex gap-2 align-items-center">
            <select class="form-select form-select-sm" [(ngModel)]="transactionType" (change)="filterTransactions(transactionType)" style="width: 200px;">
                <option value="all">All</option>
                <option value="payment">Payment</option>
                <option value="bill-payment">Bill Payment</option>
                <option value="remittance">Remittance</option>
            </select>
            <div class="ms-auto">
                <app-date-filter [fromDate]="selectedFromDate" [toDate]="selectedToDate" 
                    (dateSelected)="onDateSelected($event)"></app-date-filter>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row bg-white p-2 pt-0">
            <div class="col-md-12 mt-4 mb-5">
                <div class="table-responsive">
                    <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
                        [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </div>
</div>
